// VaultifyUK theme JS enhancements — kept global because both concerns here
// are triggered from snippets/card-product.liquid, which renders on the
// homepage, collection pages, and search — not just product pages.
// Product-page-only enhancements were moved to vaultify-product.js
// (Performance Slice 2), loaded only where those features actually exist.

(function () {

  // ── Restock Rocket — waitlist modal ──────────────────────────────────────────
  // Defined once here (loaded defer via theme.liquid) rather than inline in
  // every card-product.liquid render. Called by the waitlist button's onclick.

  window.openRestockRocketModal = async function (button) {
    try {
      const handle = button.dataset.productHandle;
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}products/${handle}.js`, {
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) throw new Error(`Failed to load product: ${handle}`);

      const product = await res.json();
      const variant =
        product.variants.find(v => v.available) ||
        product.variants[0];

      if (!variant || !window._RestockRocket || !window._RestockRocket.openModal) {
        throw new Error('Restock Rocket modal API not available');
      }

      window._RestockRocket.openModal(product, variant.id);
      button.blur();
    } catch (err) {
      console.error(err);
    }
  };

  // ── Cards: ignore a stale Restock Rocket pre-order ───────────────────────────
  // The theme decides what is a pre-order (a "Pre-order" selling plan group, snippets/vaultify-preorder-plan.liquid).
  // Restock Rocket decides from its own records, which can go stale after a product leaves a pre-order: it then relabels a
  // normal Add to cart button "Pre-order" and injects a selling plan, "Expected Dispatch" property and stoq attribute into the
  // card's form, which makes the add fail. card-product.liquid marks every NOT-pre-order Add to cart form with
  // data-vuk-add-to-cart; for those forms this undoes Restock Rocket's changes (and keeps undoing them if it re-applies).
  // Pre-order cards render a plain link instead of a form, so they are never touched.
  function vukRestoreAddToCart(wrapper) {
    var form = wrapper.querySelector('form');
    if (!form) return;
    form.querySelectorAll('.restock-rocket-form-input, [data-stoq-injected]').forEach(function (el) { el.remove(); });
    Array.prototype.slice.call(form.classList).forEach(function (c) { if (c.indexOf('restock-rocket') === 0) form.classList.remove(c); });
    var button = form.querySelector('.quick-add__submit');
    if (!button) return;
    Array.prototype.slice.call(button.classList).forEach(function (c) { if (c.indexOf('restock-rocket') === 0) button.classList.remove(c); });
    var label = wrapper.getAttribute('data-vuk-add-label');
    var span = button.querySelector('span:not(.sold-out-message)');
    if (label && span && span.textContent.trim() !== label) span.textContent = label;
  }

  function vukWatchAddToCart(wrapper) {
    if (wrapper.__vukWatched) return;
    wrapper.__vukWatched = true;
    var busy = false;
    var run = function () {
      if (busy) return;
      busy = true;
      vukRestoreAddToCart(wrapper);
      setTimeout(function () { busy = false; }, 0);
    };
    run();
    new MutationObserver(run).observe(wrapper, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  function vukScanAddToCart() {
    document.querySelectorAll('product-form[data-vuk-add-to-cart]').forEach(vukWatchAddToCart);
  }

  vukScanAddToCart();
  // Cards also arrive after load (filters, load more, search): pick up new ones.
  // Only element additions that contain (or are) a flagged form trigger a rescan, batched to one per frame.
  var vukScanQueued = false;
  new MutationObserver(function (records) {
    if (vukScanQueued) return;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('product-form[data-vuk-add-to-cart]') || n.querySelector('product-form[data-vuk-add-to-cart]'))) {
          vukScanQueued = true;
          requestAnimationFrame(function () { vukScanQueued = false; vukScanAddToCart(); });
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // ── Card secondary video — reset when the user clicks elsewhere ────────────
  // Product cards can show a play button over the second media item when it's
  // a video (see card-product.liquid + base.css .card__video-overlay). Once
  // clicked, Dawn's deferred-media element loads and plays the video inline.
  // Playback continues after the mouse leaves the card (like a normal
  // embedded video), and only resets back to the play-button state once the
  // user clicks somewhere outside the card that started it.

  function resetCardVideo(cardWrapper) {
    const deferredMedia = cardWrapper.querySelector('.card__video-overlay[loaded]');
    if (!deferredMedia) return;
    window.pauseAllMedia();
    if (deferredMedia._endMessageHandler) {
      window.removeEventListener('message', deferredMedia._endMessageHandler);
      deferredMedia._endMessageHandler = null;
    }
    const playedMedia = deferredMedia.querySelector('video, iframe');
    if (playedMedia) playedMedia.remove();
    deferredMedia.removeAttribute('loaded');
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.card__video-overlay[loaded]').forEach((deferredMedia) => {
      const owningCard = deferredMedia.closest('.card-wrapper');
      if (owningCard && !owningCard.contains(event.target)) {
        resetCardVideo(owningCard);
      }
    });
  }, true);

  // ── Card secondary video — reset when playback ends ─────────────────────────
  // Leaving a card sitting on the last video frame indefinitely isn't a great
  // state, so once the video finishes it resets back to the poster/play
  // button. Native <video> exposes a real "ended" event. External video
  // (YouTube/Vimeo iframes) has no DOM event to listen to — this reuses the
  // same raw postMessage technique pauseAllMedia() already relies on
  // (.js-youtube/.js-vimeo) rather than loading the full YouTube/Vimeo
  // player API scripts just to detect end-of-playback.

  function watchCardVideoEnd(deferredMedia) {
    const media = deferredMedia.querySelector('video, iframe');
    if (!media) return;
    const cardWrapper = deferredMedia.closest('.card-wrapper');
    if (!cardWrapper) return;

    if (media.tagName === 'VIDEO') {
      media.addEventListener('ended', () => resetCardVideo(cardWrapper), { once: true });
      return;
    }

    if (media.tagName === 'IFRAME') {
      const onMessage = (event) => {
        if (event.source !== media.contentWindow) return;
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          return;
        }
        const youTubeEnded = data.event === 'infoDelivery' && data.info && data.info.playerState === 0;
        const vimeoEnded = data.event === 'finish';
        if (youTubeEnded || vimeoEnded) resetCardVideo(cardWrapper);
      };
      deferredMedia._endMessageHandler = onMessage;
      window.addEventListener('message', onMessage);
      media.addEventListener('load', () => {
        media.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: media.id || 'card-video' }), '*');
      });
    }
  }

  // ── Card video play button — stop card-level tracking intercepting clicks ──
  // A third-party app attaches a CAPTURE-phase click listener to the card
  // (see the data-product-card-tracked / data-product-click-tracked
  // attributes it injects) that navigates to the product page on any click
  // inside the card. A capture-phase ancestor listener fires before the
  // event ever reaches the poster button, so nothing attached on the button
  // itself (bubble or capture) can stop it — attempted first and confirmed
  // insufficient. Intercepting at document capture phase (the very first
  // thing to run for any click, anywhere) is required, stopping propagation
  // before it reaches the tracking listener and manually invoking
  // deferred-media's loadContent() in its place, since stopPropagation this
  // early also prevents the event from ever reaching the button's own
  // listener naturally.

  document.addEventListener('click', (event) => {
    const posterButton = event.target.closest && event.target.closest('.card__video-overlay .deferred-media__poster');
    if (!posterButton) return;
    event.stopPropagation();
    event.preventDefault();
    const deferredMedia = posterButton.closest('deferred-media');
    if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
      deferredMedia.loadContent();
      watchCardVideoEnd(deferredMedia);
    }
  }, true);

  /* Quick add add-ons (2026-11-01). Easify draws its Quick add options through one React root that it keeps on the
     quick-add-modal element (__tpoRenderData) and never re-creates, so after the first Quick add on a page it kept drawing
     into the first, discarded copy and every later Quick add showed an empty add-ons fold. Throwing that root away when the
     modal closes makes Easify create a fresh one, drawn into the new content, the next time. */
  /* Quick add highlights (2026-11-01): moved from under the photo into the info column, under "View full details". */
  function vukQuickAddHighlights(modal) {
    let tries = 0;
    const wait = setInterval(() => {
      const list = modal.querySelector('.product__media-wrapper .product__modal-highlights');
      const link = modal.querySelector('.product__info-container .product__view-details');
      if ((!list || !link) && ++tries < 40) return;
      clearInterval(wait);
      if (list && link) link.after(list);
    }, 150);
  }

  new MutationObserver((records) => {
    records.forEach((r) => {
      const modal = r.target;
      if (modal.matches && modal.matches('quick-add-modal') && modal.hasAttribute('open')) vukQuickAddHighlights(modal);
      if (!modal.matches || !modal.matches('quick-add-modal') || modal.hasAttribute('open')) return;
      const data = modal.__tpoRenderData;
      if (!data) return;
      try { data.root.unmount(); } catch (e) { /* already gone */ }
      if (data.reactRoot) data.reactRoot.remove();
      delete modal.__tpoRenderData;
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });

})();
